import { useState } from 'react'
import { useGameStore } from '../stores/gameStore'

const ROLES = [
  { id: 'flux', name: 'FLUX', color: '#00FF66', ability: 'Flow Vision', desc: 'Widzi przeplywy danych' },
  { id: 'logic', name: 'LOGIC', color: '#4488FF', ability: 'Pattern Scan', desc: 'Rozpoznaje wzorce' },
  { id: 'spark', name: 'SPARK', color: '#FF8844', ability: 'System Link', desc: 'Aktywuje mechanizmy' },
  { id: 'echo', name: 'ECHO', color: '#AA44FF', ability: 'Signal Read', desc: 'Deszyfruje komunikaty' },
] as const

export default function MainMenu() {
  const { nickname, selectedRole, setNickname, setSelectedRole, quickJoin, joinLobby, error } = useGameStore()
  const [loading, setLoading] = useState(false)

  const handleQuickPlay = async () => {
    if (!nickname.trim()) {
      useGameStore.setState({ error: 'Wprowadz nick' })
      return
    }
    setLoading(true)
    try {
      await quickJoin()
    } finally {
      setLoading(false)
    }
  }

  const handleJoinLobby = async () => {
    if (!nickname.trim()) {
      useGameStore.setState({ error: 'Wprowadz nick' })
      return
    }
    setLoading(true)
    try {
      await joinLobby()
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="w-full h-full flex flex-col items-center justify-center bg-gradient-to-b from-emerald-dark to-gray-900 p-8">
      {/* Title */}
      <h1 className="text-4xl md:text-6xl font-bold text-emerald-neon neon-text mb-2">
        Kod Szmaragdowego Miasta
      </h1>
      <p className="text-gray-400 mb-12">Kooperacyjna gra przygodowa</p>

      {/* Error message */}
      {error && (
        <div className="bg-red-900/50 border border-red-500 text-red-300 px-4 py-2 rounded mb-4">
          {error}
        </div>
      )}

      {/* Form */}
      <div className="w-full max-w-md space-y-6">
        {/* Nickname */}
        <div>
          <label className="block text-sm text-gray-400 mb-2">Twoj nick</label>
          <input
            type="text"
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            placeholder="Wprowadz nick..."
            className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white
                       focus:border-emerald-neon focus:outline-none focus:ring-1 focus:ring-emerald-neon"
            maxLength={20}
          />
        </div>

        {/* Role selection */}
        <div>
          <label className="block text-sm text-gray-400 mb-2">Wybierz role</label>
          <div className="grid grid-cols-2 gap-3">
            {ROLES.map((role) => (
              <button
                key={role.id}
                onClick={() => setSelectedRole(role.id as any)}
                className={`p-3 rounded-lg border-2 transition-all text-left
                  ${selectedRole === role.id
                    ? 'border-current neon-border'
                    : 'border-gray-700 hover:border-gray-500'
                  }`}
                style={{ color: selectedRole === role.id ? role.color : undefined }}
              >
                <div className="font-bold" style={{ color: role.color }}>{role.name}</div>
                <div className="text-xs text-gray-400">{role.desc}</div>
              </button>
            ))}
          </div>
        </div>

        {/* Buttons */}
        <div className="space-y-3 pt-4">
          <button
            onClick={handleQuickPlay}
            disabled={loading}
            className="w-full py-3 bg-emerald-neon text-gray-900 font-bold rounded-lg
                       hover:bg-emerald-400 transition-colors disabled:opacity-50"
          >
            {loading ? 'Laczenie...' : 'Szybka gra'}
          </button>

          <button
            onClick={handleJoinLobby}
            disabled={loading}
            className="w-full py-3 bg-gray-800 border border-gray-600 text-white rounded-lg
                       hover:bg-gray-700 transition-colors disabled:opacity-50"
          >
            Przegladaj pokoje
          </button>
        </div>
      </div>

      {/* Version */}
      <p className="text-gray-600 text-sm mt-12">Faza 1 Prototyp</p>
    </div>
  )
}
